import {
  BOOKING_UPSERT_SUCCESS,
  BOOKING_UPSERT_FAIL,
  BOOKING_GETALL_SUCCESS,
  BOOKING_DELETE_SUCCESS
} from "../actions/types";

const initialState = { bookings: [], totalRows: 0 }

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case BOOKING_UPSERT_SUCCESS:
      if (state.bookings.filter(e => e.id == payload.id).length > 0) {
        return { ...state, bookings: state.bookings.map(booking => { return booking.id === payload.id ? payload : booking }) };
      } else {
        return { ...state, bookings: [...state.bookings, payload] }
      }
    case BOOKING_DELETE_SUCCESS:
      return { ...state, bookings: state.bookings.filter(booking => booking.id !== payload) }

    case BOOKING_GETALL_SUCCESS:
      return { ...state, bookings: payload.bookings, totalRows: payload.total };
    default:
      return { ...state };
  }
}